const scrollToElementByHash = () => {
    if ( ! window.location.hash ) {
        return;
    }

    const el = document.querySelector( window.location.hash );
    if ( ! el ) {
        return;
    }

    // The global offset we're going to apply to the scroll position.
    let totalOffset = 0;

    const closestSpacingParent = el.closest( '.space-y' );
    if ( closestSpacingParent ) {
        const spacePaddingTop = getComputedStyle( closestSpacingParent )?.getPropertyValue( '--space-padding-top' );
        // Check if the parent has a spacing modifier for the block-start.
        if ( spacePaddingTop ) {
            totalOffset += parseFloat( spacePaddingTop );
        } else {
            totalOffset += parseFloat( getComputedStyle( closestSpacingParent )?.getPropertyValue( '--space-padding' ) );
        }
    } else {
        totalOffset += parseFloat( getComputedStyle( document.documentElement )?.getPropertyValue( '--space-padding' ) );
    }

    document.documentElement.style.setProperty('--site-scroll-offset', `${ totalOffset }px`);

    // Timeout to prevent bubbling of the hashchange event.
    setTimeout( () => el.scrollIntoView( {
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
    } ), 10 );
};

export default scrollToElementByHash;
